'use client';

import { useState } from 'react';

import { setUser } from 'store/reducers/UserSlice';
import { getMyProfile } from 'services/admin.service';

import useAppSelector from 'hooks/redux/useAppSelector';
import useAppDispatch from 'hooks/redux/useAppDispatch';

const useMyProfile = () => {
  const { user } = useAppSelector(state => state.user);
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const refetch = async () => {
    setLoading(true);

    const { data, success } = await getMyProfile();

    if (success) {
      dispatch(setUser(data));
    }

    setLoading(false);
  };

  return {
    user,
    loading,
    refetch,
  };
};

export default useMyProfile;
